$eve_button_inline $eve_button
	variant \ghost
	colors \primary
	size \s
	label \
